import { Box } from "@mui/material";
import { isSystemUserMessage } from "../../utils/chatUtils";

function normalizeMessageRole(message) {
  return String(message?.role || "").trim().toLowerCase();
}

export function isAssistantMessage(message) {
  return normalizeMessageRole(message) === "assistant";
}

export function isUserMessage(message) {
  return normalizeMessageRole(message) === "user";
}

function isUploadUserMessage(message) {
  return isUserMessage(message) && String(message?.id || "").startsWith("upload-");
}

export function isUserTypedMessage(message) {
  return message?.source === "typed"
    || isUploadUserMessage(message)
    || (isUserMessage(message) && !isSystemUserMessage(message));
}

export default function ChatMessageBubble({ message, children }) {
  const useUserStyle = isUserTypedMessage(message);

  return (
    <Box
      component="div"
      data-testid={useUserStyle ? "intake-user-message" : "intake-system-message"}
      className={useUserStyle ? "intake-chat-user-bubble" : "intake-chat-system-bubble"}
      sx={!useUserStyle ? { width: "fit-content", maxWidth: "100%", minWidth: 0 } : undefined}
    >
      {children}
    </Box>
  );
}
